import Vue from "vue"

export default {
  namespaced: true,
  // -----------------------------------------------------------------
  state: {
    snackbar: {
      text: "",
      color: "success",
      status: false,
      timeout: 6000
    },
    alert: {
      show: false,
      type: "success",
      message: ""
    },
    isLoading: false
  },
  // -----------------------------------------------------------------
  getters: {
    // getters and computed props on the data
  },
  // -----------------------------------------------------------------
  mutations: {
    // stuff to set data locally
    updateSnackbar: (state, snackbar) => {
      state.snackbar = snackbar
    },
    updateLoadingStatus: (state, status) => {
      state.isLoading = status
    },
    updateAlert: (state, alert) => {
      state.alert = alert
      state.isLoading = false
    },
    closeAlert: state => [(state.alert.show = false)]
  },
  // -----------------------------------------------------------------
  actions: {
    showSnackbar: (context, snackbar) => {
      snackbar.status = true
      context.commit("updateSnackbar", snackbar)
    },
    showSnackbarSuccess: (context, text) => {
      context.commit("updateSnackbar", {
        status: true,
        text: text,
        color: "success",
        timeout: 6000
      })
    },
    showSnackbarError: (context, text) => {
      context.commit("updateSnackbar", {
        status: true,
        text: text,
        color: "error",
        timeout: 20000
      })
    },
    closeSnackbar: context => {
      context.commit("updateSnackbar", {
        text: "",
        color: "success",
        status: false,
        timeout: 6000
      })
    },
    startLoading: context => {
      context.commit("closeAlert")
      context.commit("updateLoadingStatus", true)
    },
    stopLoading: context => {
      context.commit("updateLoadingStatus", false)
    },
    showAlertSuccess: (context, message) => {
      context.commit("updateAlert", {
        show: true,
        message: message,
        type: "success"
      })
    },
    showAlertError: (context, message) => {
      context.commit("updateAlert", {
        show: true,
        message: message,
        type: "error"
      })
    },
    showAlert: (context, { message, type }) => {
      context.commit("updateAlert", {
        show: true,
        message: message,
        type: type
      })
    },
    closeAlert: context => {
      context.commit("closeAlert")
    }
  }
}
